<template>
  <!-- 承認待ちの申請画面 -->
  <CCard>
    <CCardHeader>
      <CRow>
        <CCol>
          <h2>承認待ちの申請</h2>
        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody>
      <!-- 出るのは自分宛ての承認待ちだけ（前は「承認済み以外」と書いていた。束5）。 -->
      <p>自身が承認者に指定されている承認待ちの提出物一覧です。「提出物」の書類名を押すと内容を確認できます。</p>
      <!-- ここに出るのは0件のときの案内だけ。失敗ではないので赤字にせず、ほかの一覧の0件の文と同じ案内の字（灰色）で出す。 -->
      <p class="text-muted" v-for="note in message" :key="note">{{ note }}</p>
      <div v-if="items.length">
        <div class="table-responsive">
          ※複数プロジェクトに所属している場合は代表プロジェクト１つを表示しています。
          <table class="table table-bordered">
            <thead>
              <tr>
                <th style="text-align: center" width="50">
                  <input
                    type="checkbox"
                    aria-label="全選択"
                    v-model="selectAll"
                    @change="toggleSelectAll"
                  />
                </th>
                <th scope="col" width="100px" nowrap>提出者名</th>
                <th scope="col" width="100px" nowrap>提出物</th>
                <th scope="col" width="100px" nowrap>年月</th>
                <th scope="col" width="100px" nowrap>プロジェクト名</th>
                <th scope="col" width="100px" nowrap>提出日</th>
                <th scope="col" nowrap>差戻し理由<span class="asterisk">*</span>（差戻し時必須）</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td style="text-align: center">
                  <!-- 読み上げの名前は、その行の提出者名・提出物・年月（無いと、値の「[object Object]」が読まれる）。 -->
                  <input type="checkbox" :aria-label="rowLabel(item)" :value="item" v-model="selectedItems" />
                </td>
                <td nowrap>{{ item.submitter_name }}</td>
                <td nowrap>
                  <router-link
                    :to="{
                      name: item.dynamic_route,
                      params: {
                        id: item.document_id,
                        user_id: item.user_id,
                        year: item.year,
                        month: item.month,
                        user_name: item.submitter_name,
                      },
                    }"
                    target="_blank"
                    >{{ item.document_name }}</router-link
                  >
                </td>
                <td nowrap>{{ item.year_month }}</td>
                <td nowrap>{{ item.project_name }}</td>
                <td nowrap>{{ formatDate(item.submission_at) }}</td>
                <td width="450">
                  <CTextarea 
                  v-model="item.comment"
                  rows="1"
                  resize: vertical
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <CRow v-if="buttonMessage.length">
          <CCol>
            <p class="preika-form-message" v-for="error in buttonMessage" :key="error">
              {{ error }}
            </p>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            Slack用補足コメント
            ※差戻し専用。承認については通知が煩雑になるためあえて通知させていません。
            <CTextarea rows="10" v-model="sns_message"></CTextarea>
          </CCol>
        </CRow>
        <br />
        <CRow class="justify-content-center">
          <CCol xs="auto">
            <div class="d-flex justify-content-center flex-wrap text-nowrap preika-action-row">
              <save-button
                v-if="!showButton"
                :label="'差戻し'"
                :loading="loading"
                class="btn btn-danger"
                @click="rejection"
              />
              <save-button
                v-if="!showButton"
                :label="'承認'"
                :loading="loading"
                class="btn btn-primary"
                @click="approval"
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import SaveButton from "../common/SaveButton";
import axios from "axios";
import { alertSubmissionError } from "./submissionErrorMessage";
import ConstList from "./../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import SubmissionConst from "./ConstList";
export default {
  components: { SaveButton },
  name: "SubmissionManagement",
  data() {
    return {
      items: [],
      message: [],
      buttonMessage: [], // ボタン押下イベントのメッセージ
      selectedItems: [], // 選択されたアイテムのIDを保持
      selectAll: false, // 全選択チェックボックスの状態
      showButton: false, // 申請ボタン・取消ボタンの表示非表示
      loading: false,
      sns_message: '', // 差戻しの Slack 用補足コメント
    };
  },
  // DBから各種情報を取得
  mounted: function () {
    axios
      .get(process.env.VUE_APP_API_ORIGIN + "/document/approval/list")
      .then((response) => {
        this.items = response.data;
        if (this.items.length === 0) {
          this.message.push(ConstList.EMPTY_ASSIGNED_APPROVALS);
          // データがない場合はボタンを非表示に設定
          this.showButton = true;
        }
      })
      .catch((error) => {
        axios
        .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
        .then(() => {
          alert(requestFailureMessage(error));
        })
        .catch(() => {
          alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
      });
  },
  methods: {
    // 承認
    approval: function () {
      // 1件も選択されていない場合
      if (this.selectedItems.length === 0) {
        this.showButtonMessage(SubmissionConst.ERROR_MESSAGE_APPROVAL, 3000);
        return;
      }
      const params = this.selectedItems.map((item) => ({
        id: item.id,
        document_type: item.document_type,
      }));
      this.$dialog
        .confirm(
          {
            title: "確認",
            body: "選択した提出物を承認しますか？",
          },
          {
            okText: "はい",
            cancelText: "キャンセル",
          }
        )
        .then(() => {
          this.loading = true;
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/submission/approval",
              params,
              {
                headers: {
                  // content-type指定。@requestBodyでサーバ側にてバインドするため。
                  "Content-Type": "application/json",
                },
              }
            )
            .then(() => {
              alert(SubmissionConst.APPROVAL_MESSAGE);
              window.location.reload();
            })
            .catch((error) => {
              /*
               * **断られた理由をそのまま出す。**
               *
               * 承認できない状態や権限のとき、400番台で返る。
               * サーバは message に利用者向けの文言を載せている。それを
               * 「システムエラーです。管理者に問い合わせてください。」へ
               * 置き換えると、**何をすれば通るのかが分からない。**
               */
              alertSubmissionError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(function () {
          // キャンセル
        });
    },
    // 差戻
    rejection: function () {
      // 1件も選択されていない場合
      if (this.selectedItems.length === 0) {
        this.showButtonMessage(SubmissionConst.ERROR_MESSAGE_REJECTION, 3000);
        return;
      }
      /*
       * 選択した提出物のコメントが空だったら返す。
       *
       * **null だけを見ていると、空文字が通る。**欄を一度も触って
       * いなければ null だが、一文字入れて消すと "" になる。実機で
       * その状態から確認ダイアログまで進み、サーバの 400 で
       * 断られていた。空白だけの理由も、理由になっていない。
       */
      const selectComment = this.selectedItems.filter(
        (item) => String(item.comment == null ? "" : item.comment).trim() === ""
      );
      if (selectComment.length > 0) {
        this.showButtonMessage(SubmissionConst.ERROR_MESSAGE_REJECT_REASON, 3000);
        return;
      }
      const params = this.selectedItems.map((item) => ({
        id: item.id,
        user_id: item.user_id,
        approver_user_id:
          item.approver_user_id === null ? item.user_id : item.approver_user_id,
        comment: item.comment,
        document_type: item.document_type,
        sns_message: this.sns_message,
        year_month: item.year_month,
      }));
      this.$dialog
        .confirm(
          {
            title: "確認",
            body: "選択した提出物を差戻しますか？",
          },
          {
            okText: "はい",
            cancelText: "キャンセル",
          }
        )
        .then(function () {
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/submission/rejection",
              params,
              {
                headers: {
                  // content-type指定。@requestBodyでサーバ側にてバインドするため。
                  "Content-Type": "application/json",
                },
              }
            )
            .then(() => {
              alert(SubmissionConst.REJECTION_MESSAGE);
              window.location.reload();
            })
            .catch((error) => {
              /*
               * **断られた理由をそのまま出す。**
               *
               * 差戻し理由が空のとき、400「差戻し理由を入力してください。」が返る。
               * サーバは message に利用者向けの文言を載せている。それを
               * 「システムエラーです。管理者に問い合わせてください。」へ
               * 置き換えると、**何をすれば通るのかが分からない。**
               */
              alertSubmissionError(error);
            });
        })
        .catch(function () {
          // キャンセル
        });
    },
    // ヘッダのチェックボックスを選択時
    toggleSelectAll() {
      if (this.selectAll) {
        // 全選択チェックボックスがチェックされた場合、全てのアイテムにチェック
        this.selectedItems = this.items.map((item) => item);
      } else {
        this.selectedItems = [];
      }
    },
    // メッセージの表示時間設定
    // ボタンの下に文を出す。**すでに出ている同じ文は足さない**（続けて押すと、同じ文が
    // 押した数だけ重なって出ていた。2026-10-09）。消すまでの時間は、最後に押した時から数え直す。
    showButtonMessage: function(text, delay) {
      if (!this.buttonMessage.includes(text)) {
        this.buttonMessage.push(text);
      }
      this.messagehideDelay(delay);
    },
    messagehideDelay: function (delay) {
      clearTimeout(this.buttonMessageTimer);
      this.buttonMessageTimer = setTimeout(() => {
        this.buttonMessage = [];
      }, delay);
    },
    // チェック欄の読み上げの名前（その行の提出者名・提出物・年月）。
    rowLabel: function (item) {
      return [item.submitter_name, item.document_name, item.year_month].filter(Boolean).join(" ");
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      // 空欄だと「まだ入力されていない」のか「表示できていない」のか
      // 見分けがつかない。ダッシュボードの承認滞留分析と同じ表記へ揃える。
      if (!dateStr) return '日時未設定';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
  watch: {
    selectedItems: function () {
      // 選択されたアイテムの数がテーブルのアイテム数と一致しない場合、全選択チェックボックスをfalseにする(外す)
      this.selectAll = this.selectedItems.length === this.items.length;
    },
  },
};
</script>

<style scoped>
td {
  word-break: break-all;
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

.form-group {
  margin-bottom: 0rem;
}
</style>
